/** ----------------------------------------
 Load More
 ---------------------------------------- */

/**
 * Creates a Load More button!
 * Load more buttons should be placed right after an element with a grid structure.
 */

import axios from 'axios';
import $ from 'jquery';

export default class LoadMore {

    constructor(element) {
        this.element = element;
        this.take = 12;

        this.loadmoreclass = element.dataset.loadmoreclass.toLowerCase();
        this.url = `/load-more/${this.loadmoreclass}`;
        this.token = element.dataset.token;
        this.skip = parseInt(element.dataset.skip) + 1;

        this.grid = element.parentElement.previousElementSibling;

        this.initClickEvent(element);
    }

    initClickEvent(element) {
        const _this = this;

        element.addEventListener('click', function () {
            _this.loadMoreElements();
        });
    }

    loadMoreElements() {
        axios.post(this.url, {
                "take": this.take,
                "skip": this.skip,
                "token": this.token
            },
            {
                "Content-Type": "Application/json"
            }).then((response) => {
            response.data[this.loadmoreclass].forEach((article) => $(this.grid).append(article));
            this.skip += this.take;

            if(!response.data.canLoadMore) {
                this.element.remove();
            }
        });
    }


}
